import type { BadgeProps } from '@mantine/core';
import { Badge } from '@mantine/core';

import styles from './Badge.module.css';

export const LBBadge = ({
  children,
  ...props
}: BadgeProps & { onClick?: () => void }) => (
  <Badge {...props} classNames={styles}>
    {children}
  </Badge>
);
